import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { applyTheme, useTheme } from './store/theme';
import { startVersionWatch } from './lib/appVersion';

// Sync persisted theme to <html> before first paint to avoid a flash.
applyTheme(useTheme.getState().theme);

// Watch for deploys so an open tab does not keep running a bundle whose lazy
// chunks have already been replaced on the server.
startVersionWatch();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
